import { Component, OnInit } from '@angular/core';
import { ActivatedRoute ,Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { BrdsqlService } from '../../services/brdsql.service';
import { FirebaseService } from '../../services/firebase.service';
import { UpdatefirebaseService } from './../../services/updatefirebase.service';
import { GetdatafirebaseService } from './../../services/getdatafirebase.service'

@Component({
  selector: 'app-editplot-part-form',
  templateUrl: './editplot-part-form.component.html',
  styleUrls: ['./editplot-part-form.component.css']
})
export class EditplotPartFormComponent implements OnInit {

  itid?: string;
  landno?: string;
  edit_id?: string;
  cpDetail?: any = [];
  cpFibaseDetail?: any = {};
  editDetail?: any = [];
  financeList?: any = [];
  factorList?: any = [];
  plotCanEdit = false;  // เชคการเบิกเกี้ยว
  plotCanEdit2 = false; // เชคการเบิกปัจจัย
  plotCanEdit3 = false; // เชคบาทต่อตัน
  plotSelect?: any = {};
  plotSelect2?: any = {};
  listPlot?: any = [];
  listPlot2?: any = [];
  fmcode?: string = "";
  oldPlot?: string = "";
  docid?: string = "";
  selectDoc?: string = null;
  selectPlot?: string = null;
  selectDoc2?: string = null;
  selectPlot2?: string = null;
  haveFinance? = false;
  haveFactor? = false;
  supzone?: any = [];
  newLandno?: string = '';
  btfm?: any = [];
  btOver? = false;
  FinanceSelect?: any = [];
  FactorSelect?: any = [];

  constructor(
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private brdservice: BrdsqlService,
    private firebaseService: FirebaseService,
    private router: Router,
    private getfirebase:GetdatafirebaseService,
    private upfirebase:UpdatefirebaseService) 
    {
    this.itid = this.route.snapshot.paramMap.get('itid');
    this.edit_id = this.route.snapshot.paramMap.get('edit_id');
    this.supzone = this.brdservice.supzone;
  }

  ngOnInit(): void {
    this.editInfo();
  }

  // ข้อมูลการขอแก้ไขแปลง
  async editInfo() {
    await this.brdservice.getEditInfo(this.edit_id)
        .subscribe({
          next: (data: any) => {
            this.editDetail = data.recordset[0];
            console.log('1.editDetail: ', this.editDetail);
            this.plotInfo();
          }
        })
    }

  // ข้อมูลพื้นฐานแปลงอ้อย จาก sql server
  async plotInfo() {
    await this.brdservice.getCpbyItid(this.itid)
      .subscribe({
        next: (data: any) => {
          this.cpDetail = data.recordset[0];
          this.fmcode = this.cpDetail.fmcode;
          this.oldPlot = this.cpDetail.intlandno;
          console.log('2.fmcode: ', this.fmcode);
          this.getBTfm();
        }
      })

  }  

  // บาทต่อตันของชาวไร่
  async getBTfm() {
    await this.brdservice.getBTFm(this.fmcode)
      .subscribe({
        next: (data: any) => {
          this.btfm = data.recordset[0];
          this.plotCanEdit3 = this.btfm.btAll > 650 ? false : true;
          this.btOver = this.btfm.btAll > 650 ? false : true;
          console.log('3.btfm ',this.btfm.btAll);
          this.plotInfoFibase1();
        }
      })
  }
  
  // ข้อมูลพื้นฐานแปลงอ้อย จาก firebase
  async plotInfoFibase() {
    await this.firebaseService.getplantbyItid(this.itid)
    .then((cpdata: any) => {
      this.cpFibaseDetail = cpdata;
      // console.log('cpFirebase :' ,this.cpFibaseDetail);
    })
  } 
  async plotInfoFibase1() {
    await this.firebaseService.getplantbyLandno(this.oldPlot,this.itid)
    .then((cpdata: any) => {
      this.cpFibaseDetail = cpdata;
      console.log('4.cpFirebase :' ,this.cpFibaseDetail);
      this.getCpFinance();
    })
  }  

  // ข้อมูลการขอสินเชื่อ ของแปลงอ้อย
  async getCpFinance() {
    let yearid = localStorage.getItem('yearTh')
    await this.brdservice.getCpFinance(yearid, this.itid)
      .subscribe({
        next: (data: any) => {
          this.financeList = data.recordset;
          console.log('5.financeList :', this.financeList);
          this.plotCanEdit = this.financeList.length > 0 ? false : true;
          this.haveFinance = this.financeList.length > 0 ? false : true;
          // console.log('plotCanEdit finance :', this.plotCanEdit);
          this.getCpFactor();
        },
        error: (e) => console.error(e)
      });
  }

  // ข้อมูลการขอปัจจัยการผลิต ของแปลงอ้อย
  async getCpFactor() {
    let yearid = localStorage.getItem('yearTh')
    await this.brdservice.getCpFactor(yearid, this.itid)
      .subscribe({
        next: (data: any) => {
          this.factorList = data.recordset;
          this.plotCanEdit2 = this.factorList.length > 0 ? false : true;
          this.haveFactor = this.factorList.length > 0 ? false : true;
          console.log('6.factorList :', this.factorList);
          // setTimeout(() => {
          //   $(this.tb_data.nativeElement).DataTable();
          // }, 0);
        },
        error: (e) => console.error(e)
      });
  }

  // แสดงวงเงินของแปลงที่เลือกที่ s_plot
  showfinance(event) {
    const sValue = event.target.value;
    // console.log('intlandno ' ,sValue);
    this.plotSelect = this.listPlot.filter((el: { intlandno: string; }) => el.intlandno == sValue);
    this.plotSelect = this.plotSelect[0];
    this.selectPlot = this.plotSelect.intlandno;
    this.itid = this.plotSelect.itid;
    // console.log('plotSelect' ,this.plotSelect);
  }

  docSelect(event) {
    const docid = event.target.value;
    this.selectDoc = docid;
    let year = localStorage.getItem('yearTh')
    this.brdservice.getFinanceSelect(docid,year)
    .subscribe({
      next: (data:any) => {
        this.FinanceSelect = data.recordsets[0];
        // console.log('FinanceSelect : ',this.FinanceSelect[0].money_amt)
        this.listPlotFm()
      }
    })
    // console.log('docid ', this.selectDoc)
  }

  docSelect2(event) {
    const docid = event.target.value;
    this.selectDoc2 = docid;
    this.listPlotFm2();
  } 
  
  selectLandno2(event) {
    const facLandno = event.target.value;
    this.selectPlot2 = facLandno;
    this.plotSelect2 = this.listPlot2.filter((el: { intlandno: string; }) => el.intlandno == facLandno);
    this.plotSelect2 = this.plotSelect2[0];
    this.selectPlot2 = this.plotSelect2.intlandno;
    this.itid = this.plotSelect2.itid;
  }   

  // แปลงอ้อยของชาวไร่ สำหรับดูวงเงินได้รับ วงเงินใช้ไป วงเงินคงเหลือ
  listPlotFm() {
    this.brdservice.listPlotFm(this.fmcode)
      .subscribe({
        next: (data: any) => {
          this.listPlot = data.recordset;
          // console.log('listPlot1 ',this.listPlot);
        }
      })
  }  

  // แปลงอ้อยของชาวไร่ สำหรับดูวงเงินได้รับ วงเงินใช้ไป วงเงินคงเหลือ
  listPlotFm2() {
    this.brdservice.listPlotFm(this.fmcode)
      .subscribe({
        next: (data: any) => {
          this.listPlot2 = data.recordset;
          console.log('listPlot2 ',this.listPlot2);
        }
      })
  }   

  // กรณีแก้ไขเจ้าของแปลง ไปประมวลผลหมายเลขแปลง ของชาวไร่ ในโซนที่เลือก
  async getNewLandno(f:any) {
    let year = localStorage.getItem('yearCr')
    await this.brdservice.getNewlandno(year,f)
    .subscribe({
      next: (data: any) => {
        // console.log('newLandno: ',data.recordset[0].newLandno)
        this.newLandno = data.recordset[0].newLandno;
      }
    })
  }  

  // บันทึกฟอร์ม โอนย้ายเกี้ยว แก้ไขแปลงของ ผจก.ส่วน
  savefrm_tranFinance(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.saveTransformFinance(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.refreshCheck();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
      // บันทึกแล้วรีเฟรซข้อมูล
      // this.router.navigateByUrl('/ListComponent', { skipLocationChange: true }).then(() => {
      //   this.router.navigate(['/editplotmanager']);
      // });

    })
  };

  // บันทึกฟอร์ม โอนย้ายปัจจัย แก้ไขแปลงของ ผจก.ส่วน
  savefrm_tranFactor(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.saveTransformFactor(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.refreshCheck();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
      // บันทึกแล้วรีเฟรซข้อมูล
      // this.router.navigateByUrl('/ListComponent', { skipLocationChange: true }).then(() => {
      //   this.router.navigate(['/editplotmanager']);
      // });

    })
  };
  
  // บันทึกการแก้ไขแปลงอ้อยไปที่ firebase realtime database
  saveEditPlot(f:any) {
    Swal.fire({
      title: 'ยืนยันการทำรายการแก้ไขแปลงอ้อย?',
      // text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, ยืนยัน!'
    }).then((result) => {
      if (result.isConfirmed) {
        let x :number = +f.fb_edit_type;
        switch(x) {
          // 1 ยกเลิกแปลง
          case 1: {
            this.firebaseService.canclePlant(f);
            this.updateEditplotStatus1();
            break;
          }
          // 2 แก้ไขประเภทอ้อย
          case 2: {
            this.firebaseService.updateCaneType(f);
            this.updateEditplotStatus1();
            break;
          }
          // 3 แก้ไขเจ้าของแปลงอ้อย
          case 3: {
            this.firebaseService.updateOwnerPlant(f);
            this.updateEditplotStatus1();
            break;
          }
          default: {
            Swal.fire('!ผิดพลาด','..ไม่พบหัวข้อการแก้ไขแปลงอ้อย หากไม่สำเร็จ ติดต่อผู้ดูแลระบบ','info')
            break;
          }
        }
        Swal.fire(
          'สำเร็จ!',
          'ยกเลิกข้อมูลแปลงอ้อยแล้ว.',
          'success'
        )
      }
    })
  }
  
  // อัพเดตว่า แก้ไขแปลงแล้วในตาราง editDataCP
  async updateEditplotStatus1() {
    await this.brdservice.updateEditPlotStatus1(this.edit_id)
    .subscribe({
      next: (data: any) => {
        console.log('api res : ',data)
        setTimeout(() => {
          window.close();
        }, 3000);
      }
    }) 
  }

  //บันทึกแล้วรีเฟรซข้อมูล
  refreshCheck() {
    // this.router.navigateByUrl('/editplotpartform', { skipLocationChange: true }).then(() => {
      // this.router.navigate(['/editplotpartform']);
      window.location.reload();
    // });
  }


}
